import { AxiosPromise } from "axios";
import BaseCefCommercialService from "./base.service";
import { CefVersion } from "./constants";
import { activityLogArea } from "../user-tracking-helper";

export type Statement = {
    documentType: string;
    documentId: string;
    data: StatementData;
}

export type StatementData = {
    requestDate: Date,
    createDate: Date,
    from: Date,
    to: Date,
    fullCustomerName: string
}

class StatementService extends BaseCefCommercialService {
    constructor(abortController: AbortController | null = null, skipValidation = false) {
        super(activityLogArea.statements, abortController);
        this.setBaseUrl(`CEFCommStatementsAPI/${CefVersion}`);

        if (skipValidation) {
            return;
        }

        this.validateCustomerNumber();
    }

    latestCacheKey = "statement.latest";

    getStatements(startDate: string | Date, endDate: string | Date) {
        const start = new Date(startDate);
        const end = new Date(endDate);

        const startParam = this.getDateString(start);
        const endParam = this.getDateString(end)

        const request = {
            customerNumber: this.customerNumber,
            dateRange: {
                start: startParam,
                end: endParam
            }
        };

        this.userTracking.read(request);

        const path = `customers/${this.customerNumber}/statements?from=${startParam}&to=${endParam}`;

        return this.createPromiseRequest(path).get<Statement[]>();
    }

    downloadStatement(documentId: string) {
        this.userTracking.download({ documentId: documentId });

        const path = `customers/${this.customerNumber}/statements/${documentId}`;
        return this.createPromiseRequest(path)
            .withResponseType("arraybuffer")
            .get<any>();
    }

    getRecentStatements(): AxiosPromise<any> {
        const path = `customers/${this.customerNumber}/statements`;
        return this.createPromiseRequest(path).get<Statement[]>();
    }
}

export default StatementService;
